import React from "react";
import Header from "../components/Header";
import Budget from "../components/Budget";
import Problem from "../components/Problem";
import Services from "../components/Services";
import Numbers from "../components/Numbers";
import Process from "../components/Process";
import Principles from "../components/Principles";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Whatsapp from "../components/util/Whatsapp";

const Home = () => {
  return (
    <> 
      <Header />
      <main>
      <Budget />
      <Services />
      <Problem />
      <Numbers />
      <Process />
      <Principles />
      <Contact fundoAnterior="white" />
      </main>
      <Whatsapp />
      <Footer />
    </>
  );
};

export default Home;
